<template>
	<el-dialog
		title="修改密码"
		:visible.sync="dialogVisible"
		width="30%"
		:before-close="handleClose"
		:close-on-click-modal="false"
	>
		<EditPass close="handleClose" @success="handleClose" style="padding: 10px 30px;"/>
	</el-dialog>
</template>

<script>
import EditPass from "./EditPass";
export default {
    components: {
        EditPass
    },
	data() {
		return {
			dialogVisible: false,
		};
	},
	methods: {
		open() {
			this.dialogVisible = true;
		},
		handleClose() {
			this.dialogVisible = false;
		},
	},
};
</script>


<style>
</style>